import { IncidentEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const create = async (data: any): Promise<any> =>
  APIManager.sendPost(IncidentEnds.CREATE, data, true, {}, {}, axios);

const getDetail = async (id: string): Promise<any> =>
  APIManager.sendGet(IncidentEnds.DETAIL(id), true, {}, {}, axios);

const getAll = async (queryString: string): Promise<any> =>
  APIManager.sendGet(IncidentEnds.GET_ALL(queryString), true, {}, {}, axios);

const deleteRecord = async (id: string): Promise<any> =>
  APIManager.sendDelete(IncidentEnds.DELETE(id), true, {}, {}, axios);

const update = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(IncidentEnds.UPDATE(id), data, true, {}, {}, axios);

const linkAISystem = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    IncidentEnds.LINK_AI_SYSTEM(id),
    data,
    true,
    {},
    {},
    axios
  );

const linkDataset = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(IncidentEnds.LINK_DATASET(id), data, true, {}, {}, axios);

const updateStatus = async (data: any): Promise<any> =>
  APIManager.sendPost(IncidentEnds.UPDATE_STATUS, data, true, {}, {}, axios);

const getHistory = async (id: string): Promise<any> =>
  APIManager.sendGet(IncidentEnds.INCIDENT_HISTORY(id), true, {}, {}, axios);

const assignIncident = async (id: string, data: any): Promise<any> =>
  APIManager.sendPut(
    IncidentEnds.ASSIGN_INCIDENT(id),
    data,
    true,
    {},
    {},
    axios
  );

const getAllDashboard = async (
  filterType: any,
  fromDate: any,
  toDate: any
): Promise<any> =>
  APIManager.sendGet(
    IncidentEnds.GET_ALL_DASHBOARD(filterType, fromDate, toDate),
    true,
    {},
    {},
    axios
  );

export const IncidentService = {
  create,
  getAll,
  deleteRecord,
  getDetail,
  update,
  linkAISystem,
  linkDataset,
  updateStatus,
  getHistory,
  assignIncident,
  getAllDashboard,
};
